var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.payload.iframe)?_c('div',{staticClass:"iframe-wrapper"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.payload.iframe)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }